import { makeStyles } from '@mui/styles';

export const useLockerDetailsPageHeaderStyles = makeStyles((theme) => ({
  outerWrapper: {
    padding: '3rem 0',
    position: 'relative'
  },
  root: {
    color: '#ffffff',
    minHeight: '140px',
    maxWidth: '900px'
  },
  titleWrapper: {
    marginBottom: '24px',
    [theme.breakpoints.down('sm')]: {
      marginBottom: '8px'
    }
  },
  title: {
    textTransform: 'capitalize',
    marginBottom: '16px',
    [theme.breakpoints.down('sm')]: {
      marginBottom: '4px'
    }
  },
  subtitle: {
    color: '#ffffffc4',
    fontSize: '1.175rem',
    minHeight: '1.85rem',
    marginBottom: '5px'
  },
  actionButtonBox: {
    position: 'absolute',
    top: '3rem',
    right: 0
  },
  size: {
    '& svg': {
      marginRight: '8px'
    },
    color: '#ffffffc4',
    textTransform: 'capitalize',
    margin: 0
  },
  badgeLabel: {
    color: '#ffffffc4',
    marginBottom: '4px',
    paddingLeft: '2px'
  },
  lowerLocker: {
    margin: 0,
    color: '#ffffffc4'
  },
  availableFor: {
    textTransform: 'uppercase' as const,
    color: '#ffffffc4'
  },
  availableForIcon: {
    height: 24,
    width: 24
  },
  reservedForNames: {
    color: '#ffffffc4',
    margin: 0
  }
}));
